import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'serial-no-update-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="serial-no cursor-pointer">
      <span class="serial-no-text" (click)="onCellClick(data)">{{ data}}</span>
    </div>
  `,
  styles: [
    `
      .serial-no {
        padding: 4px 8px;
        border-radius: 8px;
        border: 1px solid var(--bg-overlay);
        max-width: max-content;
        background-color: var(--bg-overlay);
      }

      .serial-no-text {
        font-family: var(--manrope);
        font-weight: 500;
        color: var(--text-primary);
        font-size: 14px;
      }

      .inactive {
        padding: 4px 10px;
      }
    `,
  ],
})
export class SerialNoUpdateCellComponent {
  @Input() data: any;
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  onCellClick(data: any) {
    this.cellClick.emit(data);
  }
}
